import store from '../store';
import AdTypes from './adTypes';

class AdEngine {

    constructor() {
        this.notRandomNumbers = [1, 1, 1, 1, 1, 1, 1, 1, 2, 2];
    }

    randomWithProbabilityForAd() {
        let idx = Math.floor(Math.random() * this.notRandomNumbers.length);
        return this.notRandomNumbers[idx];
    }

    getAdTypeIdByName(adTypeName) {
        return AdTypes.find((adType) => adType.name === adTypeName).id;
    }

    getRandomAd(adTypeName) {
        if(store.state.user.isPro || this.randomWithProbabilityForAd() !== 1)
            return null; // Ad skipped

        let typeId = this.getAdTypeIdByName(adTypeName);
        let possibleAds = store.state.ads.filter((ad) => ad.adType.id === typeId);
        return possibleAds[Math.floor(Math.random() * possibleAds.length)];
    }
}

export default new AdEngine();
